// Copyright © 2021 Move Closer
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export var Color;
(function (Color) {
    Color["Black"] = "black";
    Color["Blue"] = "blue";
    Color["Brand"] = "brand";
    Color["CTA"] = "cta";
    Color["Gray"] = "gray";
    Color["Green"] = "green";
    Color["White"] = "white";
    Color["Custom"] = "custom";
})(Color || (Color = {}));
